var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import cn from 'classnames';
import styles from 'core-components/src/components/modal/modal.scss';
import { Card } from './card';
const Modal = (_a) => {
    var { onClose, open, className = '', children } = _a, props = __rest(_a, ["onClose", "open", "className", "children"]);
    useEffect(() => {
        const body = document.querySelector('body');
        body.classList[open ? 'add' : 'remove'](styles.bodyNoScrollable);
    });
    const coreStyles = cn({
        [styles.modal]: true,
        [styles.open]: open,
        [className]: className
    });
    return (React.createElement("div", Object.assign({ className: coreStyles }, props),
        React.createElement(Card, { className: styles.content, distance: 2 },
            React.createElement("span", { tabIndex: 0, role: "button", className: styles.close, onClick: onClose, onKeyDown: onClose }, "\u00D7"),
            children)));
};
Modal.defaultProps = {
    onClose: () => {
        /* IMPLEMENTED BY USER */
    },
    open: false
};
export { Modal };
